export enum EnergyType {
    Electricity = "electricity",
    Gas = "gas",
}
